import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'epargn_pending_verification.title',
  },
  subTitle: {
    id: 'epargn_pending_verification.sub_title',
  },
  login: {
    id: 'login_page.form.se_connecter',
  },
});
